import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import swal from 'sweetalert';
import { getFestivalAdmin, createFestival, updateFestival } from '../../../api/contentAdminApi';
import { FESTIVAL_DATE_TYPES } from '../../../data/cmsAdminConfig';
import { CmsEditorialFields, CmsFormShell } from './CmsFormFields';
import { normalizeCmsFormData, prepareCmsPayload } from '../../../utils/cmsPublishHelpers';

const EMPTY = {
	name: '', slug: '', tagline: '', summary: '', body: '', date_type: 'variable',
	typical_month: '', how_to_participate: '', photography_tips: '', editorial_status: 'draft',
};

export default function FestivalAdminForm() {
	const { slug } = useParams();
	const history = useHistory();
	const isEdit = Boolean(slug);
	const [form, setForm] = useState(EMPTY);
	const [saving, setSaving] = useState(false);

	useEffect(() => {
		if (!isEdit) return;
		getFestivalAdmin(slug)
			.then((res) => setForm(normalizeCmsFormData(res.data?.festival || res.data, EMPTY)))
			.catch(() => swal('Error', 'Could not load festival', 'error'));
	}, [isEdit, slug]);

	const onChange = (key, value) => setForm((f) => ({ ...f, [key]: value }));

	const handleSubmit = async (e) => {
		e.preventDefault();
		setSaving(true);
		try {
			const payload = prepareCmsPayload(form);
			if (isEdit) await updateFestival(slug, payload);
			else await createFestival(payload);
			swal('Saved', 'Festival saved.', 'success');
			history.push('/admin/cms/festivals');
		} catch (err) {
			swal('Error', err.response?.data?.errors?.[0] || 'Could not save', 'error');
		} finally {
			setSaving(false);
		}
	};

	return (
		<CmsFormShell title={isEdit ? `Edit: ${form.name}` : 'New festival'} backHref="/admin/cms/festivals" onSubmit={handleSubmit} saving={saving}>
			<fieldset className="admin-cms-form__section">
				<legend>Basics</legend>
				<div className="admin-cms-form__row">
					<label><span>Name</span><input required value={form.name} onChange={(e) => onChange('name', e.target.value)} /></label>
					<label><span>Slug</span><input required value={form.slug} onChange={(e) => onChange('slug', e.target.value)} disabled={isEdit} /></label>
				</div>
				<label><span>Tagline</span><input value={form.tagline || ''} onChange={(e) => onChange('tagline', e.target.value)} /></label>
				<div className="admin-cms-form__row">
					<label>
						<span>Date type</span>
						<select value={form.date_type} onChange={(e) => onChange('date_type', e.target.value)}>
							{FESTIVAL_DATE_TYPES.map((d) => <option key={d.value} value={d.value}>{d.label}</option>)}
						</select>
					</label>
					<label><span>Typical month</span><input value={form.typical_month || ''} onChange={(e) => onChange('typical_month', e.target.value)} placeholder="e.g. October" /></label>
				</div>
				<label><span>Summary</span><textarea rows={2} value={form.summary || ''} onChange={(e) => onChange('summary', e.target.value)} /></label>
				<label><span>Body</span><textarea rows={8} value={form.body || ''} onChange={(e) => onChange('body', e.target.value)} /></label>
				<label><span>How to participate</span><textarea rows={3} value={form.how_to_participate || ''} onChange={(e) => onChange('how_to_participate', e.target.value)} /></label>
			</fieldset>
			<CmsEditorialFields form={form} onChange={onChange} />
		</CmsFormShell>
	);
}
